import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { buildMemorialDisplayName } from "@/utils/memorialDisplayName";

interface PublicMemorialCardProps {
  memorial: {
    id: string;
    first_name: string;
    last_name: string | null;
    created_at: string;
    profile_picture_url: string | null;
    plan_type: string | null;
    expires_at: string | null;
  };
  onView: (memorialId: string) => void;
}

export const PublicMemorialCard: React.FC<PublicMemorialCardProps> = ({ 
  memorial, 
  onView
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <Card 
      className="overflow-hidden hover:shadow-lg transition-shadow cursor-pointer"
      onClick={() => onView(memorial.id)}
    >
      <CardContent className="p-4 sm:p-6">
        <div className="flex items-start space-x-3 sm:space-x-4">
          <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-gray-200 flex-shrink-0 overflow-hidden">
            {memorial.profile_picture_url ? (
              <img 
                src={memorial.profile_picture_url} 
                alt={buildMemorialDisplayName(memorial)}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full bg-brand-primary/10 flex items-center justify-center">
                <span className="text-brand-primary font-semibold text-sm sm:text-lg">
                  {memorial.first_name.charAt(0)}
                </span>
              </div>
            )}
          </div>
          
          <div className="flex-grow min-w-0">
            <h3 className="text-base sm:text-lg font-semibold text-brand-primary truncate">
              {buildMemorialDisplayName(memorial)}
            </h3>
            <p className="text-xs sm:text-sm text-muted-foreground">
              Created {formatDate(memorial.created_at)}
            </p>
            
            <div className="flex items-center gap-2 mt-2 flex-wrap">
              {memorial.plan_type === 'lifetime' && (
                <Badge variant="default" className="text-xs">Lifetime</Badge>
              )}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};